var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnArrowAnchor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "9px",
    viewBox: "0 0 9 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "P_Assessment_result_report",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(-113.000000, -6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-22",
    transform: "translate(113.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 9,
    height: 14
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u2192",
    fill: "#0149DA",
    fillRule: "nonzero",
    points: "5.92761905 11.1247619 8.48 7.35333333 5.92761905 3.62 4.65142857 3.62 6.76571429 6.83904762 0.48 6.83904762 0.48 7.88666667 6.76571429 7.88666667 4.65142857 11.1247619"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnArrowAnchor);
export default __webpack_public_path__ + "static/media/icn_arrow_anchor.e0c957f082073aa6d678544d64ba1ec7.svg";
export { ForwardRef as ReactComponent };